module.exports = __webpack_public_path__ + "VIPC6.png?89c2977e8a6df35d0bc5e8f9c0c5e688";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC6.png
// module id = 69
// module chunks = 0